import { IVR_URLS } from "../../services/apiConfig.js";
import { WORKER_ERRORS } from "../../common/constants/ivrModule/workerConstants.js";
import apiClient from "../apiInstance.js";

export const getIvrWorker = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.GET_IVR_WORKER);
        const workers = response.data.policy?.value || [];
        const responseWorkers = workers.map(worker => {
          const assignedJob = worker.assignedJobs?.[0];
          const assignedDate = assignedJob ? new Date(assignedJob.assignedAt) : null;
          return {
            id: worker.id,
            state: worker.state,
            queue: worker.queues.join(", "),
            skill: worker.labels["Some-Skill"] || null,
            assignedJobId: assignedJob?.jobId || null,
            assignedAtDate: assignedDate,
          };
        });
        return responseWorkers;
    } catch (error) {
        console.error(WORKER_ERRORS.FETCH_WORKER_ERROR, error);
        throw error;
    }
};

export const addIvrWorker = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.ADD_IVR_WORKER);
        return response.data;
    } catch (error) {
        console.error(WORKER_ERRORS.ADD_WORKER_ERROR, error);
        throw error;
    }
};

export const disableIvrWorker = async ({ workerId, channelId }) => {
    try {
        const payload = {
            workerId,
            queues: [],
            availableForOffers: false,
        };
        if (channelId) {
            payload.channelId = channelId;
        }
        const response = await apiClient.post(IVR_URLS.UPDATE_IVR_WORKER, payload);
        return response.data;
    } catch (error) {
        console.error(WORKER_ERRORS.UPDATE_WORKER_ERROR, error);
        throw error;
    }
};

export const updateIvrWorker = async ({ workerId, queues, channelId }) => {
    try {
        const payload = {
            workerId,
            queues,
            channelId,
            availableForOffers: true,
        };
        const response = await apiClient.post(IVR_URLS.UPDATE_IVR_WORKER, payload);
        return response.data;
    } catch (error) {
        console.error(WORKER_ERRORS.UPDATE_WORKER_ERROR, error);
        throw error;
    }
};

export const deleteIvrWorker = async (workerId) => {
    try {
        const response = await apiClient.post(IVR_URLS.DELETE_IVR_WORKER, { workerId });
        return response.data;
    } catch (error) {
        console.error(WORKER_ERRORS.DELETE_WORKER_ERROR, error);
        throw error;
    }
};

export const removeIvrWorker = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.REMOVE_IVR_WORKER);
        return response.data;
    } catch (error) {
        console.error(WORKER_ERRORS.REMOVE_WORKER_ERROR, error);
        throw error;
    }
};

export const editIvrWorker = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.REMOVE_IVR_WORKER);
        return response.data;
    } catch (error) {
        console.error(WORKER_ERRORS.REMOVE_WORKER_ERROR, error);
        throw error;
    }
};

